/* ══════════════════════════════════════════════════════════════
   Delivery date

   Counts business days only. Weekends are always skipped; US
   public holidays are skipped when the setting is on.

   Runs against the visitor's own clock, so the date is correct
   for their timezone and never needs updating. Re-runs whenever
   the cart drawer re-renders, so the date is right there too.

   Extend HOLIDAYS when the years run out — it is the only part
   of this file that needs maintenance.
   ══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var editing = !!(window.Shopify && window.Shopify.designMode);

  var HOLIDAYS = [
    // 2026
    '2026-01-01','2026-01-19','2026-02-16','2026-05-25','2026-06-19',
    '2026-07-03','2026-09-07','2026-11-26','2026-11-27','2026-12-25',
    // 2027
    '2027-01-01','2027-01-18','2027-02-15','2027-05-31','2027-06-18',
    '2027-07-05','2027-09-06','2027-11-25','2027-11-26','2027-12-24'
  ];

  function iso(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }

  function isWorkingDay(d, skipHolidays) {
    var day = d.getDay();
    if (day === 0 || day === 6) return false;
    if (skipHolidays && HOLIDAYS.indexOf(iso(d)) !== -1) return false;
    return true;
  }

  function nextWorkingDay(d, skipHolidays) {
    var out = new Date(d);
    do { out.setDate(out.getDate() + 1); } while (!isWorkingDay(out, skipHolidays));
    return out;
  }

  function addBusinessDays(start, n, skipHolidays) {
    var d = new Date(start);
    for (var i = 0; i < n; i++) d = nextWorkingDay(d, skipHolidays);
    return d;
  }

  var fmtLong  = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  var fmtShort = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
  var fmtDay   = new Intl.DateTimeFormat('en-US', { weekday: 'long' });

  function paint(el) {
    var proc   = parseInt(el.dataset.processing, 10) || 0;
    var tmin   = parseInt(el.dataset.transitMin, 10) || 1;
    var tmax   = parseInt(el.dataset.transitMax, 10) || 1;
    var cutoff = parseInt(el.dataset.cutoff, 10);
    var mode   = el.dataset.mode || 'latest';
    var skipH  = el.dataset.holidays === '1';

    if (isNaN(cutoff)) cutoff = 14;
    if (tmax < tmin) tmax = tmin;

    var now = new Date();

    var orderDay = new Date(now);
    var today = true;
    if (!isWorkingDay(orderDay, skipH) || now.getHours() >= cutoff) {
      orderDay = nextWorkingDay(orderDay, skipH);
      today = false;
    }

    var shipDay  = addBusinessDays(orderDay, proc, skipH);
    var earliest = addBusinessDays(shipDay, tmin, skipH);
    var latest   = addBusinessDays(shipDay, tmax, skipH);

    var orderVal = el.querySelector('[data-ac-order-val]');
    var orderSub = el.querySelector('[data-ac-order-sub]');
    if (orderVal) orderVal.textContent = today ? 'TODAY' : fmtShort.format(orderDay).toUpperCase();
    if (orderSub) orderSub.innerHTML   = today ? '&nbsp;' : fmtDay.format(orderDay);

    var arriveVal = el.querySelector('[data-ac-arrive-val]');
    var arriveSub = el.querySelector('[data-ac-arrive-sub]');

    if (mode === 'range') {
      if (arriveVal) arriveVal.textContent = fmtShort.format(earliest) + ' – ' + fmtShort.format(latest);
      if (arriveSub) arriveSub.textContent = latest.getFullYear();
    } else {
      var d = mode === 'earliest' ? earliest : latest;
      if (arriveVal) arriveVal.textContent = fmtLong.format(d).toUpperCase();
      if (arriveSub) arriveSub.textContent = fmtDay.format(d);
    }

    el.dataset.acPainted = '1';
  }

  /* only touch blocks that have not been painted yet */
  function paintNew() {
    var list = document.querySelectorAll('[data-ac-delivery]:not([data-ac-painted])');
    for (var i = 0; i < list.length; i++) paint(list[i]);
  }

  function paintAll() {
    var list = document.querySelectorAll('[data-ac-delivery]');
    for (var i = 0; i < list.length; i++) paint(list[i]);
  }

  function start() {
    paintAll();

    if (editing) {
      /* The theme editor re-renders a section on every keystroke.
         A MutationObserver would fire on each of those, which is
         what made editing crawl — these events fire once instead. */
      document.addEventListener('shopify:section:load', paintAll);
      document.addEventListener('shopify:block:select', paintNew);
      return;
    }

    /* Dawn re-renders the drawer without firing an event, so watch
       the drawer only, and coalesce bursts into one repaint. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          paintNew();
        });
      }).observe(drawer, { childList: true, subtree: true });
    }

    /* for a tab left open past midnight or past the cut-off */
    setInterval(paintAll, 10 * 60 * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
